<template>
  <PageHeader
    title="Telephony"
    :breadcrumbs="[{ label: 'Admin Console' }]"
  />

  <div class="p-4">
    <div class="bg-white rounded-lg border border-gray-200">
      <TelephonyPhoneNumbers_Admin v-if="showPhoneNumbers" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue'
import TelephonyPhoneNumbers_Admin from './TelephonyPhoneNumbers_Admin.vue'

export default {
  name: 'Telephony_Admin',

  components: {
    PageHeader,
    TelephonyPhoneNumbers_Admin,
  },

  computed: {
    ...mapGetters('auth', ['current_user']),

    showPhoneNumbers() {
      return import.meta.env.VITE_ENV === 'sandbox' || this.current_user?.is_superuser
    },
  },
}
</script>
